






































// @ is an alias to /src
import apiGroupCarac from '@/api/groupCarac'
import axios from 'axios'
import { Component, Vue, Watch } from 'vue-property-decorator'
import CheckState from '@/components/shared/CheckState.vue'
import { toSubArray } from '@/utils/groupBy'
import { directPayloadQuery } from '@/utils/api'
import { AloGroupCarac, getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac'
import { AloBase } from '@/models/alo/AloBase'
import ReadConfig from '@/components/groupCarac/read/ReadConfig.vue'
import ReadCarac from '@/components/groupCarac/read/ReadCarac.vue'
/*import ReadFlux from '@/components/groupCarac/read/ReadFlux.vue'
import ReadMarques from '@/components/groupCarac/read/ReadMarques.vue'*/


@Component({
  name: 'ModifyProfils', 
  props: {
    groupCaracId:Number
  },
  components: { CheckState,ReadConfig,ReadCarac},
})

export default class ModifyProfils extends Vue {
  private groupCaracId!: number
  private showError = false
  private rightDrawer = false

  private loadingGroupCarac = false
  private loadingItemsGroupCarac = false
  caracEditable = false

  
  
 
  get isCentralWeb() {return this.$store.myGetters.isCentralWeb}
  get isDartyPro() {return this.$store.myGetters.isDartyPro}


  get groupCarac() { 
    return {...getDefaultAloGroupCarac(),...this.$store.myGetters.groupCarac[this.groupCaracId]}
  }  

  loadGroupCarac(){        
    
    this.$store.myActions.ADM_GROUP_CARAC_DETAIL_REQUEST(this.groupCaracId)
    .catch(()=>{
      this.$router.push({name:"GroupCarac"})
    })
    .finally(() => {
      this.loadingGroupCarac = false
    })
  }


  @Watch('groupCaracId')
  onGroupCaracIdChanged(){
   this.loadGroupCarac()
  }

  created(){   
    this.loadingGroupCarac = true     
    this.$store.myActions.ADM_CARAC_ENSURE().then(() =>{
      this.caracEditable  = true
      this.loadGroupCarac()      
    })      
  }
  
  get arianeItems() {
    const arianeItems =  [
        {
          text: 'GroupCarac',
          disabled: false,          
          to: {name:'GroupCarac'},
          exact:true
        }
      ]
    if(this.groupCarac) {
        arianeItems.push({
          text: this.groupCarac.libelle,
          disabled: true,          
          to: {name:''},
          exact:true
        })
    }
    return arianeItems;
  } 
  
  saveData() {
    this.rightDrawer = false;
  }

  remove(){
    const message = !this.groupCarac.grcDisabled?`Attention, ce group de caracteristique est actif. Etes-vous sûr de vouloir supprimer complètement ce group de caractéristique ?`:"Etes-vous sûr de vouloir supprimer complètement ce group de caractéristique ?"
    this.$confirm(message).then((answer)=>{
      if(answer){
        this.$store.myActions.ADM_GROUP_CARAC_DELETE_REQUEST(this.groupCarac.id).then(()=>{
          this.$router.push({name:'GroupCarac'})
        })
      }
    })
  }


}
